import React from 'react';
import { Testimonials } from '../components/home/Testimonials';

export function ReviewsPage() {
  return <Testimonials />;
}
